import React, { useCallback } from 'react';
import { generatePath } from 'react-router-dom';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import RelativeRedirect from '../../../../elements/RelativeRedirect';
import { Tab, Tabs } from '../../../../elements/Tabs';
import { LEADS_ALL_TABS, LEADS_TAB_MINE, LEADS_TAB_RECOMMENDED } from '../../tabs';
import { useRouteMatch } from 'react-router-dom';

function LeadsTabs(props) {
    const { className, tab } = props,
        i18n = useI18n(),
        { path, params } = useRouteMatch();

    const handleSelectTab = useCallback((tab) => {
        app.history.replace(generatePath(path, { ...params, tab }));
    }, [path, params]);

    if (!LEADS_ALL_TABS.includes(tab)) return <RelativeRedirect to="../.." />;

    return (
        <Tabs className={className} visibleTabs={2}>
            <Tab selected={tab === LEADS_TAB_MINE} onClick={() => handleSelectTab(LEADS_TAB_MINE)}>
                {i18n['label.tab.leads']}
            </Tab>
            {/* <Tab primary selected={tab === LEADS_TAB_RECOMMENDED} onClick={() => handleSelectTab(LEADS_TAB_RECOMMENDED)}>
                {i18n['label.tab.recommended']}
            </Tab> */}
        </Tabs>
    );
}

export default LeadsTabs;
